export const NotificationConstants = {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  DELETE_ALL_NOTIFICATIONS: 'DELETE_ALL_NOTIFICATIONS',
}
